/**
 * @generated SignedSource<<4b70219d9778ca0cb8a4863dd7cd9d7f>>
 * @relayHash 0cf6d97a0acadf596a7af92f43372c07
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 985431ac48d7bca215838e631cee5e6ac3bb3a4702735c55376dd62886fe6bea

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiAdminPagesFieldsQuery } from './uiAdminPagesFieldsQuery.graphql';

const node: PreloadableConcreteRequest<uiAdminPagesFieldsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "985431ac48d7bca215838e631cee5e6ac3bb3a4702735c55376dd62886fe6bea",
    "metadata": {},
    "name": "uiAdminPagesFieldsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
